/* global jQuery */

angular.
module("dx.webapp.exams").
factory("dxExamsNavigator", function examsNavigatorService(
	DX_EXAMS_STEPS
) {
	"use strict";

	return function getSearchString(step, examId) {
		var queryObject = {};

		if (step) {
			var stepVerified = DX_EXAMS_STEPS[step];
			if (!stepVerified) {
				throw Error("Step does not exist: " + step);
			}

			queryObject.step = step;
		}

		if (examId) {
			queryObject.id = examId;
		}

		var queryString = jQuery.param(queryObject);
		return queryString ? "?" + queryString : "";
	};
});
